import _ from 'lodash';
import FileDownloadIcon from '@mui/icons-material/FileDownload';

import { IconButton, Stack } from '@mui/material';
import { exportHtml } from 'utils/export-html';

const SaveBasedOn = ({basedOn}: {basedOn: JSX.Element}): JSX.Element => {
  return (
    <Stack justifyContent='space-between' direction='row'>
      {basedOn}
      <IconButton onClick={exportHtml} sx={{width: '30px', height: '30px'}}>
        <FileDownloadIcon/>
      </IconButton>
    </Stack>
  )
}

export default SaveBasedOn

